/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PriceItemType } from './PriceItemType';
import {
    PriceItemTypeFromJSON,
    PriceItemTypeFromJSONTyped,
    PriceItemTypeToJSON,
    PriceItemTypeToJSONTyped,
} from './PriceItemType';

/**
 * 
 * @export
 * @interface PriceItem
 */
export interface PriceItem {
    /**
     * 
     * @type {string}
     * @memberof PriceItem
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof PriceItem
     */
    amount: number;
    /**
     * 
     * @type {PriceItemType}
     * @memberof PriceItem
     */
    type: PriceItemType;
}



/**
 * Check if a given object implements the PriceItem interface.
 */
export function instanceOfPriceItem(value: object): value is PriceItem {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PriceItemFromJSON(json: any): PriceItem {
    return PriceItemFromJSONTyped(json, false);
}

export function PriceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceItem {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'amount': json['amount'],
        'type': PriceItemTypeFromJSON(json['type']),
    };
}

export function PriceItemToJSON(json: any): PriceItem {
    return PriceItemToJSONTyped(json, false);
}

export function PriceItemToJSONTyped(value?: PriceItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'amount': value['amount'],
        'type': PriceItemTypeToJSON(value['type']),
    };
}

